var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 17.77c-.194 0-.389-.034-.583-.103a1.534 1.534 0 0 1-.521-.313A32.62 32.62 0 0 1 6.5 14.917a18.054 18.054 0 0 1-1.739-2.302 10.98 10.98 0 0 1-1.063-2.146c-.243-.688-.365-1.344-.365-1.969 0-2.083.67-3.743 2.011-4.98C6.684 2.286 8.237 1.668 10 1.668c1.764 0 3.316.618 4.657 1.854 1.34 1.236 2.01 2.896 2.01 4.979 0 .625-.122 1.281-.364 1.97a10.922 10.922 0 0 1-1.063 2.145 18.125 18.125 0 0 1-1.74 2.302 32.627 32.627 0 0 1-2.396 2.437 1.534 1.534 0 0 1-.52.313c-.195.07-.39.104-.584.104ZM10 10c.459 0 .851-.163 1.178-.49a1.6 1.6 0 0 0 .489-1.177c0-.459-.164-.85-.49-1.176A1.61 1.61 0 0 0 10 6.667a1.59 1.59 0 0 0-1.177.49c-.325.327-.488.72-.49 1.176-.001.457.162.85.49 1.178.329.328.721.491 1.177.489Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.76dd6943763428b29b6574d4cef8d490.svg";
export { ForwardRef as ReactComponent };